<template>
  <div class="all_tags_container">
    <div class="menu-wrapper" :class="{ not_reversed_scroll: isTranslate }">
      <ul class="sub-menu-dropup" :class="{ not_reversed_ul: isTranslate }">
        <li
          @click="kobiSelectedItem = index"
          :class="{ active: kobiSelectedItem == index }"
          :key="index"
          v-for="(item, index) in kobiTags"
          class="dropdown-item btn btn-block btn-light-gray dp"
        >
          <span>{{ item }}</span>
        </li>
      </ul>
    </div>
    <div class="styleCard-big" :class="{ scroll: fullViewMode }">
      <div class="styleCardContentChart flex padding">
        <ul class="date-nav style3">
          <li
            v-for="tab in timeRanges"
            :key="tab.id"
            :class="{ active: selectedTagDateRange === tab.alias }"
            @click="
              () => {
                selectedTagDateRange = tab.alias;
              }
            "
          >
            {{ tab.name }}
          </li>
          <li>
            <button
              class="full-v-btn"
              @click="
                fullViewMode = !fullViewMode;
                fetchFullViewMode();
              "
              :class="{ active: fullViewMode }"
            >
              Full-V
            </button>
          </li>
        </ul>
        <!--      <div-->
        <!--          class="tree-tags-chart"-->
        <!--          v-show="-->
        <!--            !userTagsViewMode &&-->
        <!--              (CheckUserPermission( [1, 2]) && queryForCharts.show_all_tasks)-->
        <!--          "-->
        <!--      >-->
        <!--        <div class="Counters_wraper">-->
        <!--          <div v-if="tagsCounter" class="total_Counter">-->
        <!--            {{ "Total: " }}{{ tagsCounter }}-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <canvas width="1" id="users-tags-chart-big"></canvas>-->
        <!--      </div>-->
        <div class="tags-chart-root">
          <div id="users-own-tags-chart-big" class="main-chart"></div>
        </div>
        <!--      <div class="tags-chart-root" v-show="userTagsViewMode">-->
        <!--        <div class="sysChatActions">-->
        <!--          <button @click="userTagsViewMode = false">-->
        <!--            <i class="fas fa-arrow-left"></i>-->
        <!--          </button>-->
        <!--        </div>-->
        <!--        <div id="user-tags-tasks-chart-big" class="main-chart"></div>-->
        <!--      </div>-->
        <!--        <button @click="userTagsViewMode = false">-->
        <!--          <i class="fas fa-arrow-left"></i>-->
        <!--        </button>-->
      </div>
      <div class="full-view-root" v-if="fullViewMode">
        <div
          v-for="div in appends"
          :key="div"
          :id="div"
          class="full-view-section"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import hoursFormatterUtil from "@/mixins/system/hoursFormatterUtil";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import apiClientCreator from "@/helpers/api/request";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

const UsersTagsChartBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 10,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 1,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },

    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};

export default {
  name: "TagsChart.component",
  mixins: [hoursFormatterUtil, UsersPermissionCheck],
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("tasks", ["getChartQueryObject"]),
    ...mapState("tasks", ["queryForCharts", "resetQuery"])
    //
  },
  data() {
    return {
      kobiTags: ["item 1", "item 2", "menu 3", "tasks 4", "item 5", "viki 6"],
      kobiSelectedItem: 0,
      UsersTagsChartBar: UsersTagsChartBar,

      selectedTaskGraphTab: "USERS_TAGS",
      selectedDateRange: null,
      selectedTagDateRange: null,

      selectedTaskDateRange: "TODAY",
      timeRanges: [
        {
          id: 1,
          name: "T",
          alias: "TODAY"
        },
        {
          id: 2,
          name: "Y",
          alias: "YESTERDAY"
        },
        {
          id: 3,
          name: "T-W",
          alias: "WEEK"
        },
        {
          id: 4,
          name: "L-W",
          alias: "LAST_WEEK"
        },
        {
          id: 5,
          name: "T-M",
          alias: "MONTH"
        },
        {
          id: 6,
          name: "L-M",
          alias: "LAST_MONTH"
        },
        {
          id: 7,
          name: "Q",
          alias: "QUARTER"
        },
        {
          id: 8,
          name: "H-Y",
          alias: "HALF_YEAR"
        },
        {
          id: 8,
          name: "Y",
          alias: "YEAR"
        }
      ],

      fullViewMode: false,
      userTagsViewMode: false,

      ArTagsFullViewData: [],
      ArTagsTaskData: [],
      ArUsersTagsData: [],

      reqUsersTags: false,
      reqTags: false,

      tagsCounter: null,
      appends: []
    };
  },
  mounted() {
    this.defaultPresets("YEAR");
  },
  watch: {
    resetQuery: function() {
      if (this.resetQuery) {
        this.selectedDateRange = null;
        this.selectedTagDateRange = null;
        this.selectedTaskGraphTab = "USERS_TAGS";
        //this.$store.commit("tasks/setResetQuery", false);
      }
    },
    // selectedTaskDateRange:function(){
    //   this.fetchTasksTimeChart();
    // },
    getChartQueryObject: function() {
      this.allTasksChartExpendDetails = {};
      if (this.getChartQueryObject.tag_id.length === 1) {
        this.fetchTagsTasksChartBig(
          this.auth.user.id,
          "users-own-tags-chart-big"
        );
      }
      if (this.selectedTaskGraphTab === "USERS_TAGS") {
        this.userTagsViewMode = false;
        this.fetchTagsTasksChartBig(
          this.auth.user.id,
          "users-own-tags-chart-big"
        );
      }
    },
    selectedTagDateRange: function() {
      if (this.selectedTagDateRange) {
        this.$store.commit("tasks/setChartDataToTable", {
          dates: this.defaultPresets()
        });
      }
    }
  },
  methods: {
    defaultPresets(range = this.selectedTagDateRange) {
      if (range === "TODAY") {
        const today = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: today,
            end: today
          }
        };
      }
      if (range === "YESTERDAY") {
        const start = moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .format("YYYY-MM-DD");

        const end = moment().format("YYYY-MM-DD");

        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_WEEK") {
        const start = moment()
          .subtract(1, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD");
        const end = moment()
          .subtract(1, "weeks")
          .endOf("week")
          .format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const startMonth = moment()
          .startOf("month")
          .format("YYYY-MM-DD");
        const endMonth = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const startMonth = moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD");
        const endMonth = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_30_DAYS") {
        const start = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "QUARTER") {
        const start = moment()
          .startOf("quarter")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "HALF_YEAR") {
        const start = moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "YEAR") {
        const start = moment()
          .subtract(1, "year")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
    },

    fetchTagsTasksChartBig(userId, chartCanvasIdC = "tags-tasks-chart-big") {
      this.ArTagsTaskData = [];
      if (!this.reqTags) {
        this.reqTags = true;
        let tempParams = this.getChartQueryObject;
        let colors = ["#e4fffb", "#bdffe7"];
        let chartCanvasId = chartCanvasIdC;
        let tempTagObj = [];
        apiClientCreator(`tasks/stats/user_tags/${userId}`)
          .get("", { params: tempParams })
          .then(res => {
            if (res.data[0]) {
              // if(res.data[0].tags.length === 0){
              //   this.showTagsTab = false;
              //   this.selectedTaskGraphTab = 'ALL_TASKS';
              // }else{
              //   this.showTagsTab = true;
              // }
              let allData = res.data[0];
              if (
                allData.tags.length > 0 &&
                this.getChartQueryObject.tag_id.length === 1
              ) {
                let oneTagObj = allData.tags.filter(
                  tag => tag.tag_id === this.getChartQueryObject.tag_id[0]
                );
                if (oneTagObj.length > 0) {
                  this.tagTabRep =
                    oneTagObj[0].tag + ` (` + oneTagObj[0].count + `)`;
                }
              } else {
                this.tagTabRep = null;
              }
              allData.tags.map(data => {
                tempTagObj.push({
                  name: data.tag,
                  size: data.count + 5,
                  value: data.count,
                  id: data.tag_id,
                  wrkd_time: this.hoursFormatter(data.wrkd_time),
                  est_time: this.hoursFormatter(data.est_time),
                  lft_time: this.hoursFormatter(data.lft_time)
                });
              });
              if (res.data.length > 0) {
                this.tagsTreeCounter = res.data[0].tags.reduce(
                  (a, b) => a + b.count,
                  0
                );
              } else {
                this.tagsTreeCounter = null;
              }
              this.ArTagsTaskData = [{ children: tempTagObj }];
              this.createTreeMapTagChart(
                this.ArTagsTaskData,
                chartCanvasId,
                colors
              );
              this.reqTags = false;
            }
          })
          .catch(err => {
            this.reqTags = false;
          });
      }
    },

    fetchUsersTagsChartData() {
      this.ArUsersTagsData = [];
      if (!this.reqUsersTags) {
        this.reqUsersTags = true;
        let tempParams = this.getChartQueryObject;
        let chartCanvasId = "users-tags-chart-big";

        apiClientCreator(`tasks/stats/tags/users`)
          .get("", { params: tempParams })
          .then(res => {
            res.data.map(data => {
              this.ArUsersTagsData.push(data);
            });
            if (res.data.length > 0) {
              this.tagsCounter = res.data.reduce((a, b) => a + b.count, 0);
            } else {
              this.tagsCounter = null;
            }
            this.createUsersTagsChart(
              this.ArUsersTagsData,
              chartCanvasId,
              this.UsersTagsChartBar
            );
            this.reqUsersTags = false;
            if (this.ArNoCompTaskData.length > 0) {
              this.noCompCounter = this.ArNoCompTaskData.reduce(
                (a, b) => a + b.count,
                0
              );
            }
          })
          .catch(err => {
            this.reqUsersTags = false;
          });
      }
    },

    fetchTagsTasksChart(userId, chartCanvasIdC = "user-tags-tasks-chart-big") {
      this.ArTagsTaskData = [];
      if (!this.reqTags) {
        this.reqTags = true;
        let tempParams = this.getChartQueryObject;
        let colors = ["#e4fffb", "#bdffe7"];
        let chartCanvasId = chartCanvasIdC;
        let tempTagObj = [];

        apiClientCreator(`tasks/stats/user_tags/${userId}`)
          .get("", { params: tempParams })
          .then(res => {
            if (res.data[0]) {
              // if(res.data[0].tags.length === 0){
              //   this.showTagsTab = false;
              //   this.selectedTaskGraphTab = 'ALL_TASKS';
              // }else{
              //   this.showTagsTab = true;
              // }
              let allData = res.data[0];
              if (
                allData.tags.length > 0 &&
                this.getChartQueryObject.tag_id.length === 1
              ) {
                let oneTagObj = allData.tags.filter(
                  tag => tag.tag_id === this.getChartQueryObject.tag_id[0]
                );
                if (oneTagObj.length > 0) {
                  this.tagTabRep =
                    oneTagObj[0].tag + ` (` + oneTagObj[0].count + `)`;
                }
              } else {
                this.tagTabRep = null;
              }
              allData.tags.map(data => {
                tempTagObj.push({
                  name: data.tag,
                  size: data.count + 5,
                  value: data.count,
                  id: data.tag_id,
                  wrkd_time: this.hoursFormatter(data.wrkd_time),
                  est_time: this.hoursFormatter(data.est_time),
                  lft_time: this.hoursFormatter(data.lft_time)
                });
              });
              if (res.data.length > 0) {
                this.tagsTreeCounter = res.data[0].tags.reduce(
                  (a, b) => a + b.count,
                  0
                );
              } else {
                this.tagsTreeCounter = null;
              }
              this.ArTagsTaskData = [{ children: tempTagObj }];
              this.createTreeMapTagChart(
                this.ArTagsTaskData,
                chartCanvasId,
                colors
              );
              this.reqTags = false;
            }
          })
          .catch(err => {
            this.reqTags = false;
          });
      }
    },

    createUsersTagsChart(Stats, canvasId, chartOpt) {
      let allData = Stats;
      let labels = [];
      let counts = [];
      let indexId = [];
      let opt = chartOpt.options;
      allData = allData.sort((a, b) => {
        return b.count - a.count;
      });
      allData.map(data => {
        if (data.count === 0) {
          return;
        } else {
          labels.push(data.user.full_name);
          counts.push(data.count);
          indexId.push(data.user.id);
        }
      });

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Tasks",
            data: counts, //onlineTrans,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(0,255,196)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1"
          }
        ]
      };
      if (this.UsersTagsChartBuild) {
        this.UsersTagsChartBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      this.UsersTagsChartBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      ctx.onclick = evt => {
        this.clickOnUserChart(evt, indexId, this.UsersTagsChartBuild, "TAGS");
      };
    },

    createTreeMapTagChart(states, chartId, colors, tagsIds = false) {
      let allData = states;
      let canvasChartId = chartId;
      let chartColors = colors;

      let chart = anychart.treeMap(allData, "as-tree");
      $("#" + canvasChartId).html("");
      chart.container(canvasChartId);
      let customColorScale = anychart.scales.linearColor();
      customColorScale.colors(chartColors);
      chart.maxDepth(2);
      chart.headers(false);
      chart.colorScale(customColorScale);

      //functions

      if (
        canvasChartId === "tags-tasks-chart-big" ||
        canvasChartId === "users-own-tags-chart-big" ||
        canvasChartId.includes("tags-section")
      ) {
        let group = "tag";
        chart.listen("mouseOver", function(e) {
          // change the cursor style
          document.body.style.cursor = "pointer";
        });
        chart.listen("mouseOut", function(e) {
          // set the default cursor style
          document.body.style.cursor = "auto";
        });
        chart.listen("pointClick", e => {
          let valueOfTasks = e.point.get("value");
          let id = e.point.get("id");
          if (valueOfTasks === 1) {
            this.$store.dispatch("tasks/getPreOpenTaskFromChart", {
              preOpen: true,
              newTagId: id
            });
          }
          if (tagsIds) {
            tagsIds.push(id);
            id = tagsIds;
            this.$store.commit("tasks/setChartDataToTable", {
              tagId: id,
              groupId: group
            });
          } else {
            this.$store.commit("tasks/setChartDataToTable", {
              tagId: [id],
              groupId: group
            });
          }

          this.fromTags = true;
          //this.selectedTaskGraphTab = "TASKS_TIME";
        });

        chart
          .tooltip()
          .format(
            "Total: {%value}\nWorked Time: {%wrkd_time}" +
              "\nEst Time: {%est_time}" +
              `\nLeft Time: {%lft_time}`
          );
      }
      chart.padding(0);
      chart.draw();

      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    },

    fetchFullViewMode(tagsArr = this.ArTagsTaskData) {
      if (this.fullViewMode) {
        if (tagsArr[0].children.filter(data => data.value > 1).length > 0) {
          let sortedArray = tagsArr[0].children.sort(function(a, b) {
            return b.value - a.value;
          });
          let nextTagId = sortedArray[0].id;
          let tempParams = this.getChartQueryObject;
          let colors = ["#e4fffb", "#bdffe7"];
          let chartCanvasId = "tags-section-" + sortedArray[0].id;
          this.appends.push(chartCanvasId);
          let tempTagObj = [];
          tempParams.tag_id = [...tempParams.tag_id, nextTagId];
          apiClientCreator(`tasks/stats/user_tags/${this.auth.user.id}`)
            .get("", { params: tempParams })
            .then(res => {
              if (res.data[0]) {
                let allData = res.data[0];
                allData.tags.map(data => {
                  if (tempParams.tag_id.includes(data.tag_id)) {
                    return;
                  }
                  tempTagObj.push({
                    name: data.tag,
                    size: data.count + 5,
                    value: data.count,
                    id: data.tag_id,
                    wrkd_time: this.hoursFormatter(data.wrkd_time),
                    est_time: this.hoursFormatter(data.est_time),
                    lft_time: this.hoursFormatter(data.lft_time)
                  });
                });
              }
              if (res.data.length > 0) {
                this.tagsTreeCounter = res.data[0].tags.reduce(
                  (a, b) => a + b.count,
                  0
                );
              } else {
                this.tagsTreeCounter = null;
              }
              this.ArTagsFullViewData = [{ children: tempTagObj }];
              this.createTreeMapTagChart(
                this.ArTagsFullViewData,
                chartCanvasId,
                colors,
                tempParams.tag_id
              );
              this.fetchFullViewMode(this.ArTagsFullViewData);
              this.reqTags = false;
            })
            .catch(err => {
              this.reqTags = false;
            });
        }
      } else {
        this.appends = [];
      }
    },

    clickOnUserChart(evt, userIds, myChart, group) {
      const activePoints = myChart.getElementsAtEvent(evt);
      if (activePoints[0]) {
        const idx = activePoints[0]["_index"];
        let userId = userIds[idx];
        if (group === "TAGS") {
          this.userTagsViewMode = true;
          this.fetchTagsTasksChart(userId);
        }
        this.$store.commit("tasks/setChartDataToTable", {
          userId: userId,
          groupId: group
        });
      }
    }
  }
};
</script>

<style scoped>
.active {
  background-color: #c12fff !important;
  color: white;
}
.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}

.date-nav li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.all_tags_container {
  width: 100% !important;
  padding-top: 12px;
  display: flex;
  flex-direction: row-reverse;
}

.dropdown-item {
  /*margin-left: 15px;*/
  /*margin-right: 10px;*/
  height: 35px;
  min-height: 8%;
  outline: none;
  font-size: 12px;
  /*display: flex;*/
  /*text-align: left;*/
  transition: all 0.3s ease-in-out;
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-delay: 0s;
  border-radius: 0px 5px 5px 5px;
  background-color: white;
  border: 1px solid #e5e4e4;
  /*position: relative;*/
  /*z-index: 1;*/
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
  transform: scaleX(1);
}

.menu-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  height: 100% !important;
  background-color: #f5f5f5;
}

.menu-wrapper::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
.menu-wrapper {
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 5px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
  transform: scaleX(1);
  margin-left: 5px;
  max-height: 195px;
}
.styleCardContentChart {
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  background: white;
  min-height: 12rem;
  height: 100%;
}
.main-chart {
  width: 100%;
  height: 100%;
}
.styleCardContent-big {
  background: white;
  height: 300px;
}
.styleCard-big {
  width: 100%;
  height: 200px;
  font-family: Montserrat;
}
.styleCard-big.scroll {
  overflow-y: scroll;
}
.tree-tags-chart {
  position: relative;
  width: 100%;
  min-height: 100%;
}
.tags-chart-root {
  position: relative;
  width: 100%;
  min-height: 100%;
}
.padding {
  padding-right: 1rem;
  padding-bottom: 1rem;
}
.date-nav {
  max-width: 5%;
  min-width: 5%;
  max-height: 90%;
  min-height: 90%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 1;
}

.date-nav.style3 li {
  max-height: 10%;
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
  display: flex;
  /*justify-content:center;*/
  align-items: center;
}

.date-nav.style3 li:not(:last-child) {
  /*margin-right: 2px;*/
}

.date-nav li {
  max-width: 3%;
  min-width: 100%;
  max-height: 10%;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 10px;
  text-align: left;
  vertical-align: middle;
  /*line-height: 25px;*/
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  margin-left: 3px;
}

.date-nav li:not(.empty):hover {
  transform: translateY(0px);
}

.date-nav li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.flex {
  display: flex;
  align-items: stretch;
  background-color: #fff;
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
}
.full-v-btn {
  border: none;
  background-color: #efefef;
}
.full-v-btn:focus {
  outline: none;
}
.full-v-btn.active {
  background-color: #69ccff;
}
.full-view-root {
  width: 100%;
}
.full-view-section {
  width: 100%;
  height: 150px;
}
.Counters_wraper {
  position: absolute;
  display: flex;
  flex-direction: column;
  right: 15px;
  top: 28px;
  z-index: 1;
}
.total_Counter {
  font-size: 1rem;
  font-weight: bold;
  float: right;
  margin-right: 10px;
}
.sysChatActions {
  position: absolute;
  bottom: 18px;
  left: 27px;
  border-top: 1px solid #ebeff2;
  z-index: 100;
}

.sysChatActions button:hover i {
  transform: translateX(0px);
}

.sysChatActions button img {
  transition: transform 0.3s ease;
}

.sysChatActions button {
  width: 35px;
  background: none;
  border: 0;
  position: absolute;
  top: 0.1rem;
  right: 0;
  text-align: center;
  cursor: pointer;
  height: 20px;
}
.sysChatActions:focus {
  outline: none;
}
.sysChatActions button:focus {
  outline: none;
}
</style>
